import { useState } from "react";
import { FaCalendar, FaLocationArrow, FaBox } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";

import { AppDispatch, RootState } from "../../store";
import { stageInput } from "../../features/addJob/addJobSlice";
import { SingleJobCardProp } from "../../model";
import { deleteJobAction } from "../../features/allJobs/deleteJobSlice";
import { allJobsAction } from "../../features/allJobs/allJobsSlice";
import { textToUpdate } from "../../features/allJobs/editSlice";
import { capitalize } from "../../utils/capitalize";
import {
  declinedCount,
  interviewCount,
  pendingCount,
} from "../../features/stat/statSlice";
import { breakText } from "../../utils/breakText";
import { ConfirmationModal } from "../General/helpers";

const SingleJobCard: React.FC<SingleJobCardProp> = ({
  _id,
  position,
  company,
  jobLocation,
  date,
  jobType,
  jobStatus,
  handleClick,
  allJobsProp,
}) => {
  const { currentStatusPage, pageStatusSize } = useSelector(
    (store: RootState) => store.statStore
  );

  const [isModal, setIsModal] = useState<boolean>(false);

  const dispatch = useDispatch<AppDispatch>();

  const navigate: NavigateFunction = useNavigate();
  const pathname = useLocation().pathname;

  // Capitalize the first letter of company input
  const capitalizeFirstLetter: string = company.charAt(0).toUpperCase();

  const handleCloseModal = () => {
    setIsModal(false);
  };

  // Delete function to remove job from firestore
  const handleDelete = async (index: string) => {
    setIsModal(false); // close modal
    console.log(index);

    // Get status pathname
    const checkStatusArr = pathname.split("/");
    const checkStatus = checkStatusArr[checkStatusArr.length - 1];

    dispatch(deleteJobAction(index)); // Perform deletion

    if (
      checkStatus === "pending" ||
      checkStatus === "interview" ||
      checkStatus === "decline"
    ) {
      // Run any of these if on status based jobs' page to all status based jobs
      if (checkStatus === "pending") {
        dispatch(pendingCount({ currentStatusPage, pageStatusSize }));
        // console.log(statusBasedJobs);
        return;
      }
      if (checkStatus === "interview") {
        dispatch(interviewCount({ currentStatusPage, pageStatusSize }));
        return;
      }
      if (checkStatus === "decline") {
        dispatch(declinedCount({ currentStatusPage, pageStatusSize }));
      }
      return;
    }
    dispatch(allJobsAction({ currentStatusPage, pageStatusSize }));
  };

  // Function to stage the input boxes to edit in addjob page
  const handleEdit = async (index: string) => {
    const foundJob = allJobsProp.find((each: any) => each._id === index);
    dispatch(textToUpdate());
    dispatch(stageInput(foundJob));
    navigate("/dashboard/add-job");
  };

  return (
    <>
      <section className="single__job__card">
        <div
          onClick={handleClick}
          style={{ cursor: "pointer" }}
          className="body__of__card"
        >
          {/* Head of Job Card */}
          <div className="job__card__head">
            <div className="company__first__letter">
              <p>{capitalizeFirstLetter}</p>
            </div>
            <div className="job__and__company">
              <p>{breakText(position, position.length, 25)}</p>
              <p>{breakText(company, company.length, 20)}</p>
            </div>
          </div>
          <hr />

          {/* Body of Job Card */}
          <div className="location__and__date">
            <p>
              <span>
                <FaLocationArrow />
              </span>
              {breakText(jobLocation, jobLocation.length, 12)}
            </p>
            <p>
              <span>
                <FaCalendar />
              </span>
              {date}
            </p>
          </div>
          <div className="type__and__status">
            <p>
              <span>
                <FaBox />
              </span>
              {capitalize(jobType)}
            </p>
            <p
              className={`${
                jobStatus === "interview"
                  ? "addInterviewColor"
                  : jobStatus === "pending"
                  ? "addPendingColor"
                  : "addDelineColor"
              }`}
            >
              {capitalize(jobStatus)}
            </p>
          </div>
        </div>
        <div className="buttons">
          <button onClick={() => handleEdit(_id)}>Edit</button>
          <button onClick={() => setIsModal(true)}>Delete</button>
        </div>
      </section>
      {/* Delete Modal */}
      <section
        className={` delete__modal ${isModal ? "add__scale" : "remove__scale"}`}
      >
        <ConfirmationModal
          isOverlayModal={isModal}
          handleRemoveItem={() => handleDelete(_id)}
          handleCloseModal={handleCloseModal}
          modalMessage="Are you sure you want to remove this job"
        />
      </section>
    </>
  );
};

export default SingleJobCard;
